import Loader from './Loader';

export interface ChartLoadingProps {
  /** Optional label shown beneath the spinner. */
  label?: string;
  className?: string;
}

/**
 * Centered loader sized to fill the parent container — drop into a
 * `<ChartCard>`'s inner height-bound div while a chart's data is in flight.
 */
export function ChartLoading({ label, className }: ChartLoadingProps): JSX.Element {
  const classes = ['flex h-full w-full items-center justify-center', className]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes}>
      <Loader label={label} />
    </div>
  );
}

export default ChartLoading;
